import { useCssVar } from '@vueuse/core'
import { reactive, toRefs, computed, toRaw, ref } from 'vue'
import { isLightColor, log } from './helpers'
// import { addUtmExtension } from '@/converter'
import { useMessages } from './message'
import { useStorage } from '@vueuse/core'
import { initialConfig, initialOptions, voiceOptions, overrideOptions } from '@/config'
const ready = ref(false)
const widgetType = ref('chat')
const isOpenGlobal = ref(false)
const options = reactive({ ...initialOptions })
const config = reactive({ ...initialConfig })
let streamController = null
export const useWidget = () => {
  const generateMenu = (obj) => {
    log(obj)
    const menu = []
    menu.push({
      name: 'rodo',
      key: 'rodo',
      icon: obj?.rodo?.icon || '',
      text: obj.rodo?.text || ''
    })
    updateValueOptions('menu', menu)
  }
  const setSpeak = () => {
    const synth = window.speechSynthesis
    voiceOptions.lang = config.lang
    const voices = synth.getVoices().filter((s) => s.lang === config.lang)
    voiceOptions.voice = voices[1]
  }
  const init = () => {
    const xTalkParams = window.xTalkConfig
    if (typeof xTalkConfig === 'undefined') {
      return false
    }

    if (config.debug) {
      log('DATA INIT: ', { config, options })
    }

    Object.keys(xTalkParams).forEach((key) => {
      const value = xTalkParams[key]

      if (key === 'menu') {
        generateMenu(value)
        return
      } else if (key === 'utm') {
        // addUtmExtension(value)
      } else if (key === 'suggestedQuestion') {
        if (value.length !== 0) {
          const arr = value.split(';')
          updateValue('suggestedQuestion', arr)
          updateValue('suggestedQuestionQuantity', arr.length)
        }
        updateValue('initSuggestedQuestion', value)
      } else if (key === 'historyMessages') {
        useMessages().setHistory(value)
      } else if (key === 'theme' && value !== '') {
        setTheme(value)
      } else if (key === 'specialStyles') {
        setTheme(`theme-x-talk`)
        updateValue('specialStyles', true)
      } else {
        updateValue(key, value)
      }
    })

    if (Object.keys(overrideOptions).length > 0) {
      Object.keys(overrideOptions).forEach((key) => {
        updateValue(key, overrideOptions[key])
      })
    }

    if (config.saveSource === 'widget' && widgetLocalStorage.value.chat_id !== null) {
      updateValueOptions('chat_id', widgetLocalStorage.value.chat_id)
    }
    if (config.debug) {
      log('OPTIONS:', options)
      log('CONFIG: ', config)
    }
  }

  const setLogoColor = () => {
    const appColor = useCssVar('--x-talk-appBackgroundColor', document.body)
    const logoColor = useCssVar('--x-talk-colorLogo', document.body)

    const isLight = isLightColor(appColor.value)
    if (!isLight) {
      logoColor.value = '#fff'
    }
    initialOptions.isLight = isLight
  }
  const updateValue = (key, value) => {
    if (config[key] !== undefined) {
      config[key] = value
    }
    if (options[key] !== undefined) {
      options[key] = value
    }
  }
  const updateValueConfig = (key, value) => {
    config[key] = value
    if (config.debug) {
      log('UPDATE CONFIG:', key, value)
    }
  }
  const updateValueOptions = (key, value) => {
    options[key] = value
    if (config.debug) {
      log('UPDATE VALUE:', key, value)
    }
  }
  const updateMenu = (key, value) => {
    log(key, value)
    options.menu[key] = value
  }
  const isMobile = computed(() =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  )
  const getOption = (key) => {
    return toRaw(options[key])
  }
  const getConfig = (key) => {
    return toRaw(config[key])
  }
  const sendPostMessage = (data = {}, action = 'widget_message') => {
    const cloned = JSON.parse(JSON.stringify(data))
    const payload = {
      target: 'x-talk',
      data: {
        action,
        value: cloned
      }
    }
    if (config.debug) {
      log('POST_MESSAGE: ', payload)
    }
    window.parent.postMessage(payload, '*')
  }
  const reset = () => {
    widgetLocalStorage.value.chat_id = null
    widgetLocalStorage.value.firstActive = null
    widgetLocalStorage.value.lastActive = null
    Object.keys(initialOptions).forEach((key) => {
      options[key] = initialOptions[key]
    })
  }
  const getInjected = (key) => {
    return toRaw(options.injected[key]) || undefined
  }
  const setTheme = (theme) => {
    if (config.debug) {
      log('SET THEME: ', theme)
    }
    const htmlElement = document.querySelector('html')
    htmlElement.classList.forEach((className) => {
      if (className.startsWith('theme-')) {
        htmlElement.classList.remove(className)
      }
    })
    document.querySelector('html').classList.add(theme)
  }
  const widgetLocalStorage = useStorage('x-talk-widget', {
    chat_id: null,
    firstActive: null,
    lastActive: null,
    open: false
  })
  const updateLocalStorage = (key, value) => {
    if (config.saveSource === 'widget') {
      widgetLocalStorage.value[key] = value
    }
  }
  return {
    updateValueConfig,
    ...toRefs(config),
    config,
    updateValueOptions,
    options,
    isMobile,
    updateValue,
    getOption,
    getConfig,
    reset,
    streamController,
    isOpenGlobal,
    sendPostMessage,
    setLogoColor,
    setTheme,
    widgetType,
    updateMenu,
    init,
    generateMenu,
    ready,
    voiceOptions,
    setSpeak,
    getInjected,
    widgetLocalStorage,
    updateLocalStorage
  }
}
